export const defaultSettings = {
  align: 'center',
  image: 'gan-234x60',
};
